// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__BAGxV","info":"PatientInfo_info__2AuLi"};